"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _BrixelIcon = _interopRequireDefault(require("../BrixelIcon"));
var _helper = require("../../utils/helper");
var _DebounceHook = _interopRequireDefault(require("../DebounceHook"));
var _BrixelTooltip = _interopRequireDefault(require("../BrixelTooltip"));
var _BrixelAmount = _interopRequireDefault(require("./BrixelAmount"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// eslint-disable-next-line react/display-name
const BrixelInputTextStep = /*#__PURE__*/(0, _react.forwardRef)((props, refs) => {
  const {
    autofocus = false,
    className = '',
    classNameInput = '',
    disableAutocomplete = false,
    disableDelay = false,
    disabled = false,
    formatType = null,
    iconLeft = '',
    input,
    inputMode = '',
    isLoading = false,
    isLoadingColorClass = 'Dark700',
    label = null,
    labelLeft = null,
    large = false,
    maxLength = 524288,
    message = {
      help: null,
      error: null
    },
    meta = {
      dirty: false,
      invalid: false
    },
    onClear = null,
    onKeyDown = () => '',
    onKeyUp = () => '',
    placeholder = '',
    showError = true,
    showIconValidation = true,
    tooltip,
    type = 'text',
    unit = null,
    validation = false
  } = props;
  const [currentValue, setCurrentValue] = (0, _react.useState)(input.value);
  const [disabledState, setDisabledState] = (0, _react.useState)(true);
  const [unitWidth, setUnitWidth] = (0, _react.useState)(0);
  const [isFocused, setIsFocused] = (0, _react.useState)(false);
  const [getValue] = (0, _react.useState)((0, _get.default)(input, 'value', null) ? (0, _get.default)(input, 'value', '') : '');
  const localWindow = typeof window !== 'undefined' ? window : null;
  const time = disableDelay ? 150 : 500;
  const debouncedSearchTerm = (0, _DebounceHook.default)(currentValue, time);
  const inputContainerRef = (0, _react.useRef)(null);
  const ref = refs || /*#__PURE__*/_react.default.createRef();
  (0, _react.useEffect)(() => {
    if (!disableDelay && input.onChange) input.onChange(currentValue);
  }, [debouncedSearchTerm]);
  (0, _react.useEffect)(() => {
    if (disableDelay && input.onChange) input.onChange(currentValue);
  }, [currentValue]);
  (0, _react.useEffect)(() => {
    if (currentValue !== input.value) {
      setCurrentValue(input.value);
    }
  }, [input.value]);
  const onChange = val => {
    if (+val > 0 && !isNaN(+val)) {
      setCurrentValue(+val);
    }
  };
  const changeByStep = action => {
    let newVal;
    const val = currentValue || 0;
    if (action === 'dec') {
      newVal = +val - 1000;
      setCurrentValue(newVal);
    }
    if (action === 'inc') {
      newVal = +val + 1000;
      setCurrentValue(newVal);
    }
  };
  const onFocus = val => {
    if (input.onFocus) input.onFocus(val);
  };
  const onBlur = e => {
    if (input.onBlur) input.onBlur(e);
  };
  const unitEl = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (unitEl.current) {
      const unitBoxWidth = (0, _get.default)(unitEl, 'current.clientWidth', null);
      if (unitBoxWidth) setUnitWidth(unitBoxWidth);
    }
  }, [unitEl]);
  const classPadding = (0, _react.useCallback)(() => {
    if ((0, _get.default)(input, 'value', null)) {
      if (getValue.toString().length > 0 && type === 'password' || onClear && !(0, _isEmpty.default)((0, _get.default)(input, 'value', null))) {
        return 'pr-icon';
      }
    }
    return '';
  }, [(0, _get.default)(input, 'value', null)]);
  // genarate css classes fuctions
  const inputClassFunc = (0, _react.useCallback)(() => {
    let inClasses = '';
    if (typeof window !== 'undefined' && window.innerWidth < 768 && formatType === 'tel') inClasses += ' ml-1 ';
    inClasses += ' desktop ';
    if (!large && unit && unitWidth > 0) inClasses += ` pr-small-${unitWidth} `;
    if (large && unit && unitWidth > 0) inClasses += ` pr-small-${unitWidth + 16} `;
    if (disabled) inClasses += ' disabled ';
    if (meta.dirty && !meta.invalid && (formatType === 'tel' ? !(0, _isEmpty.default)((0, _get.default)(input, 'value.number', null)) : !(0, _isEmpty.default)((0, _get.default)(input, 'value', null)))) inClasses += ' valid ';
    if (meta.dirty) inClasses += ' dirty-icon ';
    if (meta.dirty && meta.invalid) inClasses += ' error ';
    if (!labelLeft) inClasses += ' w-perc-100 ';
    if (input.value && type === 'password') inClasses += ' pr-small-42 ';
    if (large) inClasses += ' large ';
    return inClasses;
  }, [localWindow, meta, disabled, unit, unitWidth, labelLeft, input.value, large]);
  // scroll focused input to avoid overlap with save bar
  (0, _react.useEffect)(() => {
    if (isFocused) {
      const inputEl = document.activeElement;
      if (inputEl && (0, _helper.bodyScrollclassFunc)()) {
        const isInputFocused = inputEl.tagName.toString().toLowerCase() === 'input';
        const bodyScrollFunc = (0, _helper.bodyScrollclassFunc)();
        if (bodyScrollFunc) {
          const parentRect = bodyScrollFunc.getBoundingClientRect();
          const parentTop = parentRect.top;
          const rect = inputEl.getBoundingClientRect();
          const skeltonHeight = rect.bottom - parentTop;
          const avilableHeight = bodyScrollFunc.clientHeight;
          const heightDiff = avilableHeight - skeltonHeight;
          const toScroll = () => {
            let finalNumb;
            const barHeight = 80;
            if (Math.sign(heightDiff) === -1) {
              finalNumb = barHeight + Math.abs(heightDiff);
            } else {
              finalNumb = barHeight - Math.abs(heightDiff);
            }
            return finalNumb;
          };
          let scrollToCord;
          if ((0, _helper.bodyScrollclassFunc)()) scrollToCord = bodyScrollFunc.scrollTop + toScroll();
          if (scrollToCord && isInputFocused && heightDiff < 80 && bodyScrollFunc.scrollTo) {
            bodyScrollFunc.scrollTo({
              top: scrollToCord,
              behavior: 'smooth'
            });
          }
        }
      } else if (inputEl && typeof window !== 'undefined') {
        const isInputFocused = inputEl.tagName.toString().toLowerCase() === 'input';
        const rect = inputEl.getBoundingClientRect();
        const skeltonHeight = rect.bottom;
        const avilableHeight = window.innerHeight;
        const heightDiff = avilableHeight - skeltonHeight;
        const toScroll = () => {
          let finalNumb;
          const barHeight = 80;
          if (Math.sign(heightDiff) === -1) {
            finalNumb = barHeight + Math.abs(heightDiff);
          } else {
            finalNumb = barHeight - Math.abs(heightDiff);
          }
          return finalNumb;
        };
        let scrollToCord;
        if (typeof document !== 'undefined' && document.scrollingElement) scrollToCord = document.scrollingElement.scrollTop + toScroll();
        if (scrollToCord && isInputFocused && heightDiff < 80) {
          window.scrollTo({
            top: scrollToCord,
            behavior: 'smooth'
          });
        }
      }
    }
  }, [isFocused]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, label && (/*#__PURE__*/_react.default.createElement("label", {
    className: `${labelLeft ? 'txtText600 mb-2 dis-b' : 'brixel-label'} ${large ? 'labelLarge' : ''}`,
    htmlFor: input.name
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: `va-tb ${tooltip ? 'mr-1' : ''}`
  }, label), tooltip && (/*#__PURE__*/_react.default.createElement(_BrixelTooltip.default, {
    className: "dis-ib",
    label: tooltip.label,
    width: tooltip.width,
    description: tooltip.description,
    theme: tooltip.theme
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: `dis-fl-col brixel-text-input-container stepInput ${disabledState ? 'disabledEdit' : ''}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f jc-b a-c"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pos-r w-perc-100"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `${labelLeft ? 'dis-f a-c jc-b row-cols-2' : 'w-perc-100'}`
  }, labelLeft && (/*#__PURE__*/_react.default.createElement("span", {
    className: "txtText900 labelLeft"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: `va-tb ${tooltip ? 'mr-1' : ''}`
  }, labelLeft), tooltip && !label && (/*#__PURE__*/_react.default.createElement(_BrixelTooltip.default, {
    className: "dis-ib",
    label: tooltip.label,
    width: tooltip.width,
    description: tooltip.description,
    theme: tooltip.theme
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f a-c pos-r input-container",
    ref: inputContainerRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `w-perc-100 pos-r ${disabledState ? 'cur-poi' : ''}`,
    onClick: () => setDisabledState(false)
  }, iconLeft && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    color: "dark",
    saturationTxt: 700,
    className: "leftIcon pos-a-fix pl-small-10",
    icon: iconLeft
  })), formatType === 'price' ? (/*#__PURE__*/_react.default.createElement(_BrixelAmount.default, {
    className: `brixel-text-input ${type === 'password' ? '' : `${classPadding()} ${inputClassFunc()}`} ${classNameInput} ${iconLeft ? 'left-icon' : ''} ${input.inputType === 'search' ? 'search-offset' : ''}`,
    name: input.name,
    groupSeparator: unit === 'CHF' ? '\'' : '.',
    decimalSeparator: unit === 'CHF' ? '.' : ',',
    value: currentValue,
    onValueChange: e => onChange(e)
  })) : (/*#__PURE__*/_react.default.createElement("input", {
    role: type || 'text',
    id: input.name,
    "data-validation": validation,
    autoComplete: disableAutocomplete ? 'chrome-off' : '',
    className: `brixel-text-input ${classPadding()} ${inputClassFunc()} ${classNameInput} ${disabledState ? 'disableState' : ''}`,
    value: currentValue,
    name: formatType === 'tel' ? `${input.name}_number` : input.name,
    disabled: disabled || disabledState,
    placeholder: (0, _helper.transifexTranslate)(placeholder),
    // min={type === 'number' ? '-1' : ''}
    type: !type ? 'text' : type,
    onChange: e => onChange(e.target.value),
    onBlur: e => {
      onBlur(e);
      setIsFocused(false);
    },
    onFocus: e => {
      onFocus(e.target.value);
      setIsFocused(true);
    },
    ref: ref,
    autoFocus: autofocus,
    maxLength: maxLength,
    onKeyDown: () => onKeyDown(),
    onKeyUp: () => onKeyUp(),
    pattern: type === 'number' || inputMode === 'decimal' ? '\\d*' : undefined,
    inputMode: 'decimal',
    onWheel: e => e.currentTarget.blur()
  })), placeholder && (/*#__PURE__*/_react.default.createElement("span", {
    className: "hiddentext"
  }, placeholder)), unit && (/*#__PURE__*/_react.default.createElement("span", {
    className: `inputUnit ${large ? 'px-2' : 'px-1'}`,
    ref: unitEl
  }, unit))), /*#__PURE__*/_react.default.createElement("div", {
    className: `wrap-brixel-input-step dis-f jc-b ${large ? 'pr-1' : ''}`
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "dec notranslate brdSmall brdCircle brdPrimary400 w-fix-24 h-fix-24 dis-f a-c jc-c",
    onClick: () => changeByStep('dec'),
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    iconWidth: "w-fix-16",
    icon: "minus",
    color: "primary"
  })), /*#__PURE__*/_react.default.createElement("button", {
    className: "inc notranslate brdSmall brdCircle brdPrimary400 w-fix-24 h-fix-24 dis-f a-c jc-c",
    onClick: () => changeByStep('inc'),
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    iconWidth: "w-fix-16",
    color: "primary",
    icon: "plus"
  }))))), isLoading && (/*#__PURE__*/_react.default.createElement("div", {
    className: "inputLoader"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "lds-ring"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${isLoadingColorClass}`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${isLoadingColorClass}`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${isLoadingColorClass}`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${isLoadingColorClass}`
  })))), meta.dirty === true && meta.invalid && showError && !unit && (0, _get.default)(message, 'error', true) !== true && !isLoading && type !== 'password' && showIconValidation && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    className: "validation-icon error",
    icon: "alert"
  })))), ((0, _get.default)(message, 'help', null) || (0, _get.default)(meta, 'invalid', null) && showError) && (/*#__PURE__*/_react.default.createElement("span", {
    className: `message ${(0, _get.default)(meta, 'dirty', null) && (0, _get.default)(meta, 'invalid', null) ? 'error-message' : ''} ${labelLeft ? 'ta-r' : ''}`
  }, (0, _get.default)(meta, 'dirty', null) && (0, _get.default)(meta, 'invalid', null) && showError ? (0, _get.default)(message, 'error', '') : (0, _get.default)(message, 'help', '')))));
});
var _default = exports.default = BrixelInputTextStep;